<template>
  <section class="wrapper-data spacing-py-10">
    <b-loading data-cy="LOADING" :isFullPage="false" :active="isLoading" />
    <div
      class="main-content spacing-py-15"
      :class="isMobile ? 'spacing-px-10' : 'spacing-px-25'"
    >
      <div>
        <div class=" spacing-mb-10">
          <label class="has-text-weight-semibold spacing-mr-5">{{
            `${General.OPENING_DATE} `
          }}</label>
          <span>{{ new Date(process.date) | dateFormat("DD/MM/YYYY") }}</span>
          <span>{{ ` às ` }}</span>
          <span>{{ new Date(process.date) | dateFormat("HH:mm:ss") }}</span>
        </div>

        <div v-if="process.reference_number">
          <label class="has-text-weight-semibold">
            {{ General.PROTOCOL_REFERENCE }}
          </label>
          <div class="external-process">
            <span>
              {{ process.reference_number || "" }}
            </span>
            <b-icon
              v-if="referenceNumberDetails"
              icon="information"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
            />
            <span v-if="referenceNumberDetails">{{
              referenceNumberDetails.description
            }}</span>
          </div>
        </div>

        <section class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">
            {{ General.OPENING_PART_UNIT }}
          </label>
          <div
            v-if="process.external_system_abbreviation"
            class="is-flex is-align-items-center has-text-weight-normal"
          >
            <b-icon
              icon="information-outline"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              size="is-small"
            />
            <span class="ml-5">
              {{ General.PROCESS_REGISTERED }}
              {{ process.external_system_abbreviation }}
            </span>
          </div>
          <template v-if="checkObjectHasKeys(process.origin)">
            <div
              v-if="checkObjectHasKeys(process.origin.entity)"
              class="has-text-weight-normal"
            >
              {{
                `${process.origin.entity.name} - ${process.origin.entity.abbreviation}`
              }}
            </div>
            <div class="has-text-weight-normal">
              {{
                `${process.origin.description} - ${process.origin.abbreviation}`
              }}
            </div>
          </template>
        </section>

        <section
          v-if="process.cc && process.cc.length"
          class="section-style spacing-my-10"
        >
          <label class="is-6 has-text-weight-semibold">
            {{ General.INTERESTED }}
          </label>
          <template v-if="Array.isArray(process.cc)">
            <div
              v-for="(cc, index) in process.cc"
              :key="index"
              class="has-text-weight-normal"
            >
              {{ getCCFormated(cc) }}
            </div>
          </template>
          <div v-else class="has-text-weight-normal">
            {{ process.cc }}
          </div>
        </section>

        <section class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">{{
            General.SUBJECT
          }}</label>
          <span class="is-3 has-text-weight-normal">
            {{ process.subject.name }}
          </span>
        </section>

        <section v-if="process.observation" class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">{{
            General.NOTES
          }}</label>
          <span class="is-3 has-text-weight-normal custom-break">
            {{ process.observation }}
          </span>
        </section>
      </div>

      <div class="side-inputs">
        <b-field :label="General.ACCESS_LEVEL" customClass="has-text-color-7">
          <b-dropdown
            v-if="canChangeSecrecy && !process.is_archived"
            v-model="secrecySubject"
            :mobileModal="false"
            role="listbox"
            class="dropdown-field"
            expanded
          >
            <b-button
              slot="trigger"
              slot-scope="{ active }"
              class="subject-config-select"
              type="is-secondary"
              :iconRight="active ? 'chevron-up' : 'chevron-down'"
              outlined
              expanded
              role="button"
            >
              <span>{{ secrecySubject ? secrecySubject.name : "" }}</span>
            </b-button>
            <b-dropdown-item
              v-for="(secrecy, index) in selectableSecrecies"
              :key="index"
              :value="secrecy"
              aria-role="listitem"
              :aria-description="
                `${General.ARIA_LABEL.ACCESS_LEVEL} ${secrecy.name}`
              "
              @click="onSelectedSecrecy(secrecy)"
            >
              <span class="has-text-weight-semibold">{{ secrecy.name }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <span v-else>{{ secrecySubject.name }}</span>
        </b-field>

        <b-field v-if="isConfidential" customClass="has-text-color-7">
          <template #label>
            <span class="mr-10">{{ General.CONFIDENTIAL_PERIOD }}</span>
            <b-tooltip
              multilined
              role="tooltip"
              :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              :size="isMobile ? 'is-medium' : 'is-large'"
              position="is-top"
            >
              <template v-slot:content>
                <h6 class="has-text-weight-semibold is-flex">
                  {{ App.MenuMain.HELP }}
                </h6>
                <p class="has-text-left">
                  {{ General.TEXTS.CONFIDENTIAL_PERIOD }}
                </p>
              </template>
              <div class="is-flex">
                <b-icon
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  size="is-small"
                  icon="information"
                />
              </div>
            </b-tooltip>
          </template>

          <b-dropdown
            v-if="canChangeSecrecy && !process.is_archived"
            id="period_secrecy_subject"
            v-model="confidentialityPeriod"
            data-cy="PERIOD_CONFIDENTIAL"
            aria-role="list"
            scrollable
            maxHeight="200"
            class="dropdown-field is-full-child"
            :disabled="!canChangeSecrecy"
          >
            <b-button
              slot="trigger"
              slot-scope="{ active }"
              class="subject-config-select has-text-left"
              type="is-secondary"
              :iconRight="active ? 'chevron-up' : 'chevron-down'"
              outlined
            >
              <span>{{ confidentialityPeriod.description }}</span>
            </b-button>
            <b-dropdown-item
              v-for="period in listPeriod"
              :key="`period-${period.ref}`"
              :value="period"
              aria-role="priorityItem"
              role="option"
              @click="setSecrecyPeriod(period)"
            >
              <span class="has-text-weight-semibold">{{
                period.description
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <span v-else>
            {{ confidentialityPeriod.description }}
          </span>
        </b-field>

        <b-field
          v-if="changedLegalReference"
          customClass="has-text-color-7"
          class="is-flex is-flex-direction-column"
        >
          <template #label>
            <label class="mr-10">{{ General.LEGAL_REFERENCE }}</label>
            <b-tooltip
              multilined
              role="tooltip"
              :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              :size="isMobile ? 'is-medium' : 'is-large'"
              position="is-top"
            >
              <template #content>
                <h6 class="has-text-weight-semibold is-flex">
                  {{ App.MenuMain.HELP }}
                </h6>
                <p class="has-text-left">
                  {{ General.TEXTS.DESCRIPTION_LEGAL_REFERENCE }}
                </p>
              </template>
              <div class="is-flex">
                <b-icon
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  size="is-small"
                  icon="information"
                />
              </div>
            </b-tooltip>
          </template>
          <div class="legal-tags">
            <div class="spacing-p-10">
              <b-tooltip
                v-for="(tag, index) in legalRefSubject"
                :key="`fixed_reference_${index}`"
                :label="tag.description"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-top"
                class="is-size-6"
                :size="isMobile ? 'is-small' : 'is-medium'"
                :active="tag.description.length > 27"
                multilined
              >
                <b-tag
                  class="tag-field has-tag-ellipsis is-clickable mr-5"
                  rounded
                  closable
                  :tabstop="false"
                  :aria-close-label="
                    `${General.ARIA_LABEL.DELETE_TAG} ${tag.description}`
                  "
                  @close="showMessageSecrecy()"
                >
                  {{ truncate(tag.description, { length: 27 }) }}
                </b-tag>
              </b-tooltip>
              <b-tooltip
                v-for="(tag, index) in legalReferenceUser"
                :key="`user_reference_${index}`"
                :label="tag.description"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-top"
                class="is-size-6"
                :size="isMobile ? 'is-small' : 'is-medium'"
                :active="tag.description.length > 27"
                multilined
              >
                <b-tag
                  rounded
                  class="tag-field is-clickable has-text-blue-oil tag-user-add"
                  type="is-white"
                  :closable="canChangeSecrecy"
                  @close="removeLegalReference(tag.id)"
                >
                  {{ truncate(tag.description, { length: 27 }) }}
                </b-tag>
              </b-tooltip>
            </div>
            <b-button
              v-if="canChangeSecrecy"
              class="pl-5"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              outlined
              role="button"
              @click="openModalLegalReference(false)"
            >
              {{ General.CLICK_TO_ADD }}
            </b-button>
          </div>
        </b-field>

        <b-field :label="General.PRIORITY_LEVEL" customClass="has-text-color-7">
          <b-dropdown
            v-if="
              hasPermission(userPermissions['PROCESS_PRIORITY']) &&
                !process.is_archived
            "
            v-model="prioritySubject"
            :mobileModal="false"
            role="listbox"
            class="dropdown-field"
            expanded
          >
            <b-button
              slot="trigger"
              slot-scope="{ active }"
              class="subject-config-select"
              type="is-secondary"
              :iconRight="active ? 'chevron-up' : 'chevron-down'"
              outlined
              expanded
              role="button"
            >
              <span>{{ prioritySubject ? prioritySubject.name : "" }}</span>
            </b-button>
            <b-dropdown-item
              v-for="(priority, index) in priorities"
              :key="index"
              :value="priority"
              aria-role="listitem"
              :aria-description="
                `${General.ARIA_LABEL.PRIORITY_LEVEL} ${priority.name}`
              "
              @click="onSelectedPriority(priority)"
            >
              <span class="has-text-weight-semibold">{{ priority.name }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <span v-else>{{ prioritySubject.name }}</span>
        </b-field>

        <b-field
          v-if="process.due_date && process.due_date.length > 0"
          :label="General.DUE"
          customClass="has-text-color-7"
        >
          <div
            v-if="canChangeSecrecy && !process.is_archived"
            role="button"
            @click.stop="showModalScheduler(true)"
          >
            <div
              class="cursor-pointer due-date-hover"
              :class="{ 'has-text-danger': getDateDiff < 0 }"
            >
              <b-icon icon="clock" type="is-warning" class="mr-5" />
              {{ new Date(dates.end) | dateFormat("DD/MM/YYYY") }}
              {{ `( ${getDateDiff} dias )` }}
            </div>
          </div>

          <div v-else class="spacing-mb-10">
            <b-icon icon="clock" type="is-warning" class="mr-5" />
            {{ new Date(process.due_date[0].date) | dateFormat("DD/MM/YYYY") }}
            {{ `( ${getDateDiff} dias )` }}
          </div>
        </b-field>
      </div>
    </div>

    <div
      class="main-content spacing-py-15 spacing-my-20"
      :class="isMobile ? 'spacing-px-10' : 'spacing-px-25'"
    >
      <div>
        <section class="spacing-my-10">
          <label class="is-6 has-text-weight-semibold">
            {{ App.ProcessDetailsScreen.STATE_ON_DATE }}
          </label>
          <span>{{ new Date() | dateFormat("DD/MM/YYYY") }}</span>
          <span>{{ ` às ` }}</span>
          <span>{{ new Date() | dateFormat("HH:mm") }}</span>
        </section>
        <div>
          {{ process.status }}
        </div>

        <section v-if="process.capacity_id" class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">
            {{ General.CURRENT_ENTITY_UNIT }}
          </label>
          <div class="has-text-weight-normal">
            {{ entityDescription }}<br />{{ capacityDescription }}
          </div>
        </section>
      </div>

      <div v-if="!isMobile" class="section-style spacing-pt-10">
        <qrcode-vue
          class="align-self-center qrcode-border"
          :value="`${getOriginUrl}/consultar-processo?nup=${process.nup}`"
          :size="100"
          level="H"
        />
        <div
          class="has-text-grey has-text-centered spacing-pt-5 qrcode-subtitle"
        >
          {{ General.TEXTS.ACCESS_PROCESS_QRCODE }}
        </div>
      </div>
    </div>
    <div class="row-cards">
      <div
        v-if="isAppenderProcess"
        class="main-content cards spacing-py-15 spacing-mb-20"
        :class="isMobile ? 'spacing-px-10' : 'spacing-px-25'"
      >
        <section class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">
            {{ General.APPENDED_PROCESS }}
          </label>
          <div>
            <span
              v-for="(appendedProcess, index) in process.process_join_set"
              :key="appendedProcess.id"
            >
              <b-tooltip
                :label="appendedProcess.subject"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-top"
                :size="isMobile ? 'is-small' : 'is-medium'"
                multilined
              >
                <routerLink
                  class="link"
                  role="link"
                  rel="search external"
                  :to="`/app/processos/detalhamento/${appendedProcess.id}`"
                >
                  {{ applyMaskNUP(appendedProcess.nup) }}
                </routerLink> </b-tooltip
              ><span>{{
                process.process_join_set.length - 1 > index ? ", " : ""
              }}</span>
            </span>
          </div>
        </section>
      </div>
      <div
        v-if="isAppendProcess"
        class="main-content cards spacing-py-15 spacing-mb-20"
        :class="isMobile ? 'spacing-px-10' : 'spacing-px-25'"
      >
        <section class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">
            {{ General.APPENDED_TO_PROCESS }}
          </label>
          <div>
            <b-tooltip
              :label="process.process_join.subject"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              position="is-top"
              :size="isMobile ? 'is-small' : 'is-medium'"
              multilined
            >
              <routerLink
                class="link"
                role="link"
                rel="search external"
                :to="`/app/processos/detalhamento/${process.process_join.id}`"
              >
                {{ applyMaskNUP(process.process_join.nup) }}
              </routerLink>
            </b-tooltip>
          </div>
        </section>
      </div>
      <div
        v-if="processReferences.length"
        class="main-content cards spacing-py-15 spacing-mb-20"
        :class="isMobile ? 'spacing-px-10' : 'spacing-px-25'"
      >
        <section class="section-style spacing-my-10">
          <label class="is-6 has-text-weight-semibold">{{
            General.REFERENCE_PROCESS
          }}</label>
          <div>
            <span
              v-for="(referenceProcess, index) in processReferences"
              :key="index"
            >
              <b-tooltip
                :label="referenceProcess.subject"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-top"
                :size="isMobile ? 'is-small' : 'is-medium'"
                multilined
              >
                <routerLink
                  class="link"
                  role="link"
                  rel="search external"
                  :to="`/app/processos/detalhamento/${referenceProcess.id}`"
                >
                  {{ applyMaskNUP(referenceProcess.nup) }}
                </routerLink> </b-tooltip
              ><span>{{
                processReferences.length - 1 > index ? ", " : ""
              }}</span>
            </span>
          </div>
        </section>
      </div>
    </div>
    <div
      class="is-flex mb-5 is-justify-content-space-between"
      @click="checkCanTramit"
    >
      <b-tooltip
        :label="General.MESSAGES.ALERT_PROCESS_NOTIFICATION_ENALBED"
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        role="tooltip"
        :active="process.enabled_process_notifications"
      >
        <div class="is-flex is-align-items-center">
          <b-checkbox
            v-model="notificationEmail"
            class="spacing-my-10"
            size="is-medium"
            :type="isContrast ? 'is-white' : 'is-green'"
            role="checkbox"
            :disabled="
              !process.can_tramit || process.enabled_process_notifications
            "
          />
          <label class="spacing-mr-10"
            >{{ General.TEXTS.RECEIVE_PROCESS_DATA }}
          </label>
        </div>
      </b-tooltip>
      <div>
        <b-tooltip
          :active="!process.can_tramit"
          :label="getViewTooltipLabelExternalSystem"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          role="tooltip"
          :position="isMobile ? 'is-top' : 'is-left'"
          class="mx-15 mb-10"
        >
          <b-button
            v-if="canSeeProcessSize"
            type="is-green-lawn"
            :disabled="!process.can_tramit"
            @click="showProcessSize"
          >
            {{ General.PROCESS_SIZE }}
          </b-button>
        </b-tooltip>
        <b-tooltip
          :label="
            process.can_tramit
              ? General.MESSAGES.TO_VIEW_COVER_DESCRIPTION
              : getViewTooltipLabelExternalSystem
          "
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          role="tooltip"
          :position="isMobile ? 'is-top' : 'is-left'"
          class="mx-15 mb-10"
        >
          <b-button
            type="is-green-lawn"
            :disabled="!process.can_tramit"
            @click="downloadCover"
          >
            {{ General.TO_VIEW_COVER }}
          </b-button>
        </b-tooltip>
        <b-tooltip
          :label="
            process.can_tramit
              ? General.MESSAGES.GIVE_KNOWLEDGE_COVER_DESCRIPTION
              : getViewTooltipLabelExternalSystem
          "
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          role="tooltip"
          :position="isMobile ? 'is-top' : 'is-left'"
        >
          <b-button
            type="is-green-lawn"
            :disabled="!process.can_tramit"
            @click="showModalGiveKnowledge"
          >
            {{ General.GIVE_KNOWLEDGE_COVER }}
          </b-button>
        </b-tooltip>
      </div>
    </div>
    <div class="footer-style">
      <b-tooltip
        :label="General.FAVOR"
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        role="tooltip"
      >
        <b-button
          class="spacing-mr-10"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          :disabled="!process.can_tramit"
          outlined
          role="button"
          @click="setFavoriteProcess"
        >
          <b-icon
            size="is-small"
            :icon="process.favorite ? 'star' : 'star-outline'"
            :type="isContrast ? 'is-white' : favoriteColor"
          />
        </b-button>
      </b-tooltip>
      <DropdownTagButton
        :key="`bookmark_${process.id}`"
        :process="process"
        :bookmarkList="bookmarkList"
        @selectedBookmark="setBookmarks"
      />
    </div>
  </section>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { mapActions, mapGetters } from "vuex";
import { truncate } from "lodash";
import infoOutline from "@/assets/svg/info-outline.svg";

import ModalSelectUser from "@/views/App/ModalSelectUser";
import ModalScheduler from "@/views/App/ModalScheduler";
import ModalLegalReference from "@/views/App/ModalLegalReference.vue";

import DropdownTagButton from "@/components/DropdownTagButton";

import { App, General } from "@/utils/constants";
import { getProtocolMask, NUP, applyMask } from "@/utils/protocols";
import {
  USER_PERMISSIONS as userPermissions,
  PRIORITY as priorities,
  SECRECY_ID as secrecyId,
  SECRECY as secrecies
} from "@/utils/enumerate";
import { showErrorMessage } from "@/utils/messageUtility";
import { checkObjectHasKeys } from "@/utils/dataManipulation";
import { downloadFile } from "@/utils/fileUtility";
import ModalProcessSize from "@/views/App/ModalProcessSize.vue";

export default {
  name: "ProcessData",

  components: {
    QrcodeVue,
    DropdownTagButton
  },

  props: {
    process: {
      required: true,
      type: Object
    },
    bookmarkList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      App,
      General,
      priorities,
      secrecies,
      truncate,
      infoOutline,
      notificationEmail: false,
      referenceNumberDetails: null,
      secrecySubject: {},
      prioritySubject: {},
      confidentialityPeriod: { description: General.SELECT_LEVEL_PERIOD },
      userPermissions,
      dates: {
        start: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000),
        end:
          this.process.due_date && this.process.due_date.length
            ? new Date(this.process.due_date[0].date)
            : new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)
      },
      isLoad: true,
      isLoading: false,
      filterLegalReference: "",
      legal_reference: [],
      checkObjectHasKeys
    };
  },

  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      getFilteredLegalReference: "getFilteredLegalReference",
      getCapacityById: "getCapacityById",
      hasPermission: "hasPermission",
      isConfidentialCheck: "isConfidentialCheck",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),
    hasPeriod() {
      return this.confidentialityPeriod.ref;
    },
    isConfidential() {
      return (
        this.isConfidentialCheck(this.secrecySubject?.id) && this.hasPeriod
      );
    },
    listPeriod() {
      const maxPeriod = this.secrecySubject?.id
        ? this.getSecreciesById(this.secrecySubject.id).period
        : 0;

      return Array.from({ length: maxPeriod }, (_, index) => ({
        description: `${index + 1} ${index === 0 ? "ano" : "anos"}`,
        ref: index + 1
      }));
    },
    legalRefSubject() {
      const changeSecrecySubject =
        this.secrecySubject?.id !== this.process.subject.category.secrecy.id;
      return changeSecrecySubject
        ? []
        : this.process.subject.category.legal_reference;
    },
    legalReferenceUser() {
      const subjectRefIds = this.legalRefSubject.map(ref => ref.id);
      return this.legal_reference.filter(
        ({ id }) => !subjectRefIds.includes(id)
      );
    },
    changedLegalReference() {
      const isIncludeOnProcess = [
          secrecyId.RESTRICTED,
          secrecyId.CONFIDENTIAL,
          secrecyId.SECRET_CONFIDENTIAL,
          secrecyId.TOP_SECRET_CONFIDENTIAL
        ].includes(this.process.secrecy),
        changed = this.process.secrecy !== this.secrecySubject?.id;

      return (isIncludeOnProcess && changed) || this.legal_reference.length;
    },
    getDateDiff() {
      const startDate = new Date();
      const endDate = new Date(this.dates.end);

      const millisecondsPerDay = 86400 * 1000;

      const diff = endDate - startDate;

      return Math.ceil(diff / millisecondsPerDay);
    },
    getOriginUrl() {
      return window.location.origin;
    },
    isAppenderProcess() {
      return Boolean(this.process.process_join_set?.length);
    },
    isAppendProcess() {
      return Boolean(this.process.process_join);
    },
    processReferences() {
      return this.process.process_reference;
    },
    favoriteColor() {
      return this.process.favorite ? "is-yellow" : "is-blue-oil";
    },
    capacityDescription() {
      const capacity = this.getCapacityById(this.process.capacity_id);
      if (!capacity) return "";
      return `${capacity.description} - ${capacity.abbreviation}`;
    },
    entityDescription() {
      const capacity = this.getCapacityById(this.process.capacity_id);
      if (!capacity) return "";
      return `${capacity.entity.name} - ${capacity.entity.abbreviation}`;
    },
    selectableSecrecies() {
      return this.secrecies.filter(secrecy => secrecy.selectable);
    },
    canChangeSecrecy() {
      return this.hasPermission(userPermissions["PROCESS_SECRECY"]);
    },
    canSeeProcessSize() {
      return this.hasPermission(userPermissions["SEE_PROCESS_SIZE"]);
    },
    getViewTooltipLabelExternalSystem() {
      return `${General.MESSAGES.WARNING_INTEGRATION_PROCESS_SYSTEM}: ${this.process.external_system_abbreviation}`;
    }
  },

  watch: {
    notificationEmail: {
      handler(value) {
        this.setNotificationProcess(value);
      }
    },

    secrecySubject(processSecrecy) {
      const period = this.getSecrecyPeriod(processSecrecy.id);
      this.updateConfidentialityPeriod(period);
    },

    changedLegalReference: {
      handler(value) {
        if (!value) {
          this.legal_reference = [];
        }
      }
    },

    legal_reference: {
      async handler(value) {
        if (
          this.changedLegalReference &&
          this.canChangeSecrecy &&
          !this.isLoad
        ) {
          const bodyProcess = {};

          if (this.secrecySubject?.id !== this.process.secrecy) {
            bodyProcess.secrecy = this.secrecySubject.id;
            bodyProcess.confidentiality_period = this.getSecrecyPeriod(
              this.secrecySubject.id
            );
          }
          bodyProcess.legal_reference = value.filter(item => item.id);

          const success = await this.modifiedProcess({
            process_id: this.process.id,
            data: bodyProcess
          });

          if (!success) {
            this.legal_reference = this.process.legal_reference;
            this.secrecySubject = this.getSecreciesById(this.process.secrecy);
          }
        }
      }
    }
  },

  async beforeMount() {
    await this.legalReferenceRequest();
  },

  async mounted() {
    if (this.process.user_notification) {
      this.notificationEmail = this.process.user_notification.email;
    }
    if (this.process.enabled_process_notifications)
      this.notificationEmail = true;

    if (this.process.reference_number)
      this.referenceNumberDetails = await getProtocolMask(
        this.process.reference_number
      );

    this.secrecySubject = this.getSecreciesById(this.process.secrecy);
    this.prioritySubject = this.getPrioritiesById(this.process.priority);
    this.legal_reference = this.process.legal_reference.map(item => ({
      ...item,
      description_trunc: item.description.replace(/ \(.+/g, "")
    }));

    this.$nextTick(() => {
      this.updateConfidentialityPeriod(this.process.confidentiality_period);
      this.isLoad = false;
    });
  },

  methods: {
    ...mapActions({
      modifiedProcess: "modifiedProcess",
      modifiedBookmark: "modifiedBookmarkProcess",
      createLegalReference: "legalReferenceCreate",
      getCurrentDocumentDetails: "printableVersionRequest",
      requestFile: "requestDataProcessFile",
      setFavoriteProcessRequest: "setFavoriteProcess",
      getProcessSize: "getProcessSizeAction",
      legalReferenceRequest: "legalReferenceRequest"
    }),

    setSecrecyPeriod(period) {
      if (period?.ref) {
        this.modifiedProcess({
          process_id: this.process.id,
          data: {
            confidentiality_period: period.ref,
            secrecy: this.secrecySubject.id
          }
        });
        this.updateConfidentialityPeriod(period.ref);
        this.snackToast.open({
          message: General.CONFIDENTIAL_PERIOD_UPDATED,
          position: "is-top",
          type: "is-success",
          duration: 8000
        });
      }
    },

    updateConfidentialityPeriod(period) {
      this.confidentialityPeriod = {
        description: `${period || 0} ${period === 1 ? "ano" : "anos"}`,
        ref: period
      };
    },

    getSecrecyPeriod(secrecyId) {
      const secrecy = this.getSecreciesById(secrecyId);
      if (!secrecy?.period) return undefined;
      const subjectCategory = this.process.subject.category;

      if (
        subjectCategory.confidentiality_period &&
        subjectCategory.secrecy.id === secrecyId
      ) {
        return subjectCategory.confidentiality_period;
      }

      return secrecy.period;
    },

    checkCanTramit() {
      if (!this.process.can_tramit)
        showErrorMessage(General.MESSAGES.WARNING_INTEGRATION_PROCESS);
    },

    getPrioritiesById(id) {
      return this.priorities.find(option => option.id === id);
    },

    getSecreciesById(id) {
      return this.secrecies.find(option => option.id === id);
    },

    goToProcess(id) {
      window.location.replace("/app/processos/detalhamento/" + id);
    },
    setNotificationProcess(email) {
      !this.isLoad &&
        this.modifiedProcess({
          process_id: this.process.id,
          data: {
            user_notification: {
              email,
              sms: false
            }
          }
        });
    },

    setLegalReference(text) {
      this.filterLegalReference = text;
    },

    async setFavoriteProcess() {
      if (!this.process.can_tramit)
        return showErrorMessage(General.MESSAGES.WARNING_INTEGRATION_PROCESS);
      const result = await this.setFavoriteProcessRequest([
        {
          process_id: this.process.id,
          favorite: !this.process.favorite
        }
      ]);
      result &&
        this.$store.commit("setCurrentProcess", {
          ...this.process,
          favorite: !this.process.favorite
        });
    },

    async setBookmarks(selectedBookmarks) {
      const bookmarks = selectedBookmarks;

      await this.modifiedBookmark({
        process_id: this.process.id,
        data: { bookmarks }
      });

      return bookmarks;
    },

    onSelectedSecrecy() {
      if (this.user.id !== this.process.user_responsible_id) {
        this.snackToast.open({
          message: General.MESSAGES.ALERT_CHANGE_SECRECY_RESPONSIBLE,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
        this.secrecySubject = this.getSecreciesById(this.process.secrecy);
        return;
      }

      this.openModalLegalReference(true);
    },

    onSelectedPriority(option) {
      if (option.id === 2) {
        this.showModalScheduler();
      } else {
        this.process.due_date = null;
        this.modifiedProcess({
          process_id: this.process.id,
          data: {
            due_date: null,
            priority: option.id
          }
        });
      }
    },

    onDateSelect(value) {
      this.modifiedProcess({
        process_id: this.process.id,
        data: {
          due_date: {
            date: value.end,
            is_weekdays: value.isWeekdays
          },
          priority: 2
        }
      });
      this.dates = value;
      this.process.due_date = [value.end];
    },

    showModalScheduler(canCancel = false) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalScheduler,
        props: {
          dates: this.dates,
          onSelect: this.onDateSelect
        },
        canCancel: canCancel ? ["escape", "x", "outside"] : [],
        hasModalCard: true,
        trapFocus: true
      });
    },
    getCCFormated(cc) {
      if (cc.user_name) return cc.user_name;
      if (cc.user_cpf) return cc.user_cpf;

      const capacity = this.getCapacityById(cc.capacity_id);
      if (capacity?.entity)
        return `${capacity.entity.abbreviation}/${
          capacity.abbreviation.includes("/")
            ? capacity.abbreviation.split("/")[1]
            : capacity.abbreviation
        } - ${capacity.description}`;
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    openModalLegalReference(changeSecrecy) {
      if (this.canChangeSecrecy) {
        const changeSecrecyProcess =
          this.secrecySubject?.id !== this.process.secrecy;
        const changeSecrecySubject =
          this.secrecySubject?.id !== this.process.subject.category.secrecy.id;
        const refLegal = changeSecrecySubject
          ? []
          : this.process.subject.category.legal_reference;

        this.$buefy.modal.open({
          parent: this,
          component: ModalLegalReference,
          props: {
            list: changeSecrecyProcess
              ? refLegal
              : this.process.legal_reference,
            listFromSubject: refLegal,
            mandatory: changeSecrecy,
            process: this.process,
            change: newlist => {
              if (newlist.length === 0 && refLegal.length === 0) {
                this.secrecySubject = this.getSecreciesById(
                  this.process.secrecy
                );
                this.snackToast.open({
                  message: General.MESSAGES.ALERT_CHANGE_SECRECY,
                  position: "is-top",
                  type: "is-danger",
                  duration: 8000
                });
              } else {
                this.legal_reference = newlist.concat(refLegal);
              }
            }
          },
          onCancel: () => {
            if (changeSecrecy) {
              this.snackToast.open({
                message: General.MESSAGES.ALERT_CHANGE_SECRECY,
                position: "is-top",
                type: "is-danger",
                duration: 8000
              });
            }
            this.secrecySubject = this.getSecreciesById(this.process.secrecy);
          },
          hasModalCard: true,
          trapFocus: true
        });
      }
    },

    async showProcessSize() {
      const result = await this.getProcessSize(this.process.id);
      if (result) {
        this.$buefy.modal.open({
          parent: this,
          component: ModalProcessSize,
          props: {
            currentSize: result.total_size
          },
          hasModalCard: true,
          trapFocus: true
        });
      }
    },

    async downloadCover() {
      this.isLoading = true;
      const result = await this.requestFile({
        fileIds: [{ process_file_id: this.process.cover_id }],
        processId: this.process.id
      });
      if (result) {
        const [{ url_file, attachment_name }] = result;
        downloadFile({
          url: url_file,
          attachment_name: `${attachment_name} ${this.process.nup}.pdf`
        });
      }
      this.isLoading = false;
    },

    showModalGiveKnowledge() {
      const { cover_id } = this.process;

      this.$buefy.modal.open({
        parent: this,
        component: ModalSelectUser,
        props: {
          fileIds: [
            {
              id: cover_id,
              attachment_name: `Capa ${this.process.nup}`
            }
          ],
          process: this.process,
          processCover: true
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    async removeLegalReference(removeId) {
      if (this.canChangeSecrecy) {
        const legal_reference = this.legal_reference.filter(
          item => item.id && item.id !== removeId
        );

        this.isLoading = true;
        const success = await this.modifiedProcess({
          process_id: this.process.id,
          data: {
            legal_reference,
            confidentiality_period: this.confidentialityPeriod.ref
          }
        });
        this.isLoading = false;
        const index = this.legal_reference.findIndex(
          ({ id }) => removeId === id
        );
        if (success) this.legal_reference.splice(index, 1);
      }
    },
    showMessageSecrecy() {
      this.snackToast.open({
        message: this.General.MESSAGES.ALERT_REMOVE_LEGAL_REFERENCE,
        type: "is-warning",
        duration: 8000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.wrapper-data {
  display: flex;
  flex-direction: column;
}

.main-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: $color-2;

  @media screen and (max-width: $tablet) {
    flex-direction: column;
  }

  .external-process {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
}

.main-content div:nth-child(2) .qrcode-border {
  border: 15px solid #ffffff;
}

.main-content div.qrcode-subtitle {
  width: 150px;
  font-size: 12px;
}

.align-self-center {
  display: flex;
  align-self: center;
}

.section-style {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  font-weight: 500;
}

.side-inputs {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  max-width: 300px;
}

.footer-style {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  button {
    background-color: transparent !important;
    color: $blue-oil !important;
  }
}

.due-date-hover {
  display: flex;
  align-items: center;
  padding: 5px;
  border: 1px solid #e1e1e1;
  background-color: $color-21;
  color: $color-7;
  border-radius: 4px;
  &:hover {
    transition: 0.5s;
    color: $color-22;
  }
}

.subject-config-select {
  min-width: 100%;
  justify-content: space-between;
}
.legal-tags {
  display: flex;
  flex-flow: column;
  min-width: 100%;
  width: 300px;
  background-color: $color-21;
  border: 1px solid $grey-lighter;
  border-radius: 6px;
  box-shadow: 0 0 1px $grey-lighter;
  .tooltip-content {
    font-size: 1rem;
  }
  button {
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .tag {
    margin: 2px 0;
    font-size: 1rem;
    justify-content: space-between;
    span {
      max-width: 70%;
    }
  }
}
.link {
  text-decoration: underline;
  color: inherit;
  &:hover {
    color: $primary;
  }
}
.row-cards {
  display: flex;
  gap: 10px;

  @media screen and (max-width: $tablet) {
    flex-direction: column;
    gap: 0;
  }

  .cards {
    width: 100%;
    font-size: 12px;
  }
}

.dropdown-field {
  button {
    background-color: $color-21;
    color: $color-7;
  }
}

.tag-field {
  background-color: $color-15;
  color: $color-7;
  border: 1px solid $custom-color-f2f2f2;
}
</style>
